import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  Typography,
  Box
} from "@mui/material";

const DashboardEvents = () => {
  const baseURL = process.env.REACT_APP_API_URL;
  const [events, setEvents] = useState({
    birthdays: [],
    anniversaries: []
  });

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await axios.get(`${baseURL}dashboard/dashboard-events`);
      setEvents(res.data);
    } catch (err) {
      console.error(err);
    }
  };
const getAnniversaryText = (date) => {
  const d = new Date(date);
  const today = new Date();

  const years = today.getFullYear() - d.getFullYear();

  const formattedDate = d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
  });

  return `${formattedDate} (${years} yrs)`;
};

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      
      {/* 🎂 Birthdays */}
      <Card sx={{ minWidth: 300 }}>
        <CardContent>
          <Typography variant="h6">🎂 Today’s Birthdays</Typography>

          {events.birthdays.length === 0 ? (
            <Typography>No birthdays today</Typography>
          ) : (
            events.birthdays.map((b) => (
              <Typography key={b.id}>
                🎉 {b.emp_name} - {getAnniversaryText(b.dob)} 
              </Typography>
            ))
          )}
        </CardContent>
      </Card>

      {/* 🎉 Anniversaries */}
      <Card sx={{ minWidth: 300 }}>
        <CardContent>
          <Typography variant="h6">🎉 Work Anniversaries</Typography>

          {events.anniversaries.length === 0 ? (
            <Typography>No anniversaries today</Typography>
          ) : (
            events.anniversaries.map((a) => {
              const years =
                new Date().getFullYear() -
                new Date(a.joining_date).getFullYear();

              return (
                <Typography key={a.id}>
                  🎊 {a.emp_name} - {getAnniversaryText(a.joining_date)}
                </Typography>
              );
            })
          )}
        </CardContent>
      </Card>

    </Box>
  );
};

export default DashboardEvents;